module.exports = __webpack_public_path__ + "h5/img/hong-kong-business-registration-thumb.083802ee.webp";